import swiperFn from "./modules/swiper.js";
import burgerMenu from "./modules/burger.js";
import animatedText from "./modules/animated-text.js";
import moveReactBlock from "./modules/move-react-box.js";
import parallax from "./modules/parallax.js";
import modal from "./modules/modal.js";
import twoPicturesAnimation from "./modules/two-pictures-animation.js";
import validation from "./modules/validation.js";
import ajaxContactForm from "./modules/ajaxContactForm.js";
import { enableSplashScreen } from "./modules/lottie-animations.js";
import activateBliKundeForm from "./modules/unifon-bli-kunde.js";
import AOS from "aos";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import { initiateGlobalPrisliste } from "./modules/unifon-global-prisliste.js";
import { initiatePostTypeList } from "./modules/unifon-post-type.js";
import setupGoogleMaps from "./modules/google-maps.js";
import initiateAllItemScroller from "./modules/unifon-text-items-scroller.js";
import initCF7 from "./modules/cf7.js";

setupGoogleMaps();

/**
 * Only for debugging and development
 */
const ENABLE_FEATURE_DEBUG_REFRESH = false;
const ENABLE_FEATURE_DEBUG_AUTO_REFRESH = false;
const ENABLE_FEATURE_DEBUG_SPLASH_SKIP = false;

const enableUploadButtons = () => {
  jQuery(".js-file-upload-button")
    .unbind("click")
    .bind("click", (el) => {
      const _this = el.currentTarget;
      jQuery("input[type=file]", jQuery(_this).parent("label")).click();
    });

  jQuery(".c-file-upload").each((item) => {
    const _info_element = jQuery(".c-file-upload-filename", item);
    jQuery("[type=file]", item)
      .unbind("change")
      .bind("change", (el) => {
        const filename = jQuery(el.currentTarget).val().split("\\").pop();
        _info_element.html(`: ${filename}`);
      });
  });
};

document.addEventListener("DOMContentLoaded", () => {
  const lenis = new Lenis({
    autoRaf: true,
  });

  if (ENABLE_FEATURE_DEBUG_SPLASH_SKIP) {
    if (window.location.hash != "#componentindev") {
      enableSplashScreen();
    }
  } else {
    enableSplashScreen();
  }

  new modal(".c-modal", ".l-modal-container", lenis);

  const firstLinkItem = document.querySelector(
    ".c-animated-text__item.is-link"
  );
  if (firstLinkItem) {
    firstLinkItem.classList.add("first-is-link");
  }

  const buttonsHoverClick = (button) => {
    button.addEventListener("mouseenter", function () {
      // button.classList.remove('leave');
      button.classList.add("hover");
    });

    button.addEventListener("mouseleave", function () {
      button.classList.remove("hover");
      button.classList.add("leave");
      setTimeout(function () {
        button.classList.remove("leave");
      }, 400);
    });
  };

  document.querySelectorAll(".u-btn").forEach(buttonsHoverClick);
  document.querySelectorAll(".mobile-bli-kunde-btn").forEach(buttonsHoverClick);

  const form_validator = new validation({
    errorsContainer: "form.js-contact-form .js-validation-errors",
  });

  if (document.querySelector("form.js-contact-form")) {
    form_validator.validate("firstName", 'form.js-contact-form [name="name"]');
    form_validator.validate(
      "firstName",
      'form.js-contact-form [name="surname"]'
    );
    form_validator.validate("email", 'form.js-contact-form [name="email"]');
    form_validator.validate("phone", 'form.js-contact-form [name="phone"]');
  }

  ajaxContactForm("form.js-apply-job-form", "#accept_eula");

  parallax();

  animatedText();

  AOS.init({
    // AOS settings (optional)
    duration: 800, // Animation duration in milliseconds
    offset: 50,
    // once: true, // The animation only fires once when scrolling.
  });



  jQuery(document).ready(function($) {
    // Add aria-hidden="true" to AOS elements initially
    $('[data-aos]').attr('aria-hidden', 'true');

    // Toggle aria-hidden on scroll
    $(window).on('scroll', function() {
        $('[data-aos].aos-animate').attr('aria-hidden', 'false');
        $('[data-aos]:not(.aos-animate)').attr('aria-hidden', 'true');
    });

    // Handle elements already in view on page load
    $('[data-aos]').each(function() {
        if ($(this).hasClass('aos-animate')) {
            $(this).attr('aria-hidden', 'false');
        }
    });
  });


  burgerMenu(lenis);

  swiperFn();

  moveReactBlock();

  twoPicturesAnimation();
  enableUploadButtons();
  initiateGlobalPrisliste();
  initiatePostTypeList();

  activateBliKundeForm("#headerContactForm");
  activateBliKundeForm("#kontaktskjemaForm");
  activateBliKundeForm("#bliKundeForm");

  initiateAllItemScroller();
  initCF7();


});

if (ENABLE_FEATURE_DEBUG_REFRESH) {
  window.refreshWithCacheParam = () => {
    window.location =
      window.location.origin +
      window.location.pathname +
      "?_q=" +
      new Date().getTime() +
      "#componentindev";
  };

  jQuery("#wp-admin-bar-root-default").append(
    '<li role="group" id="wp-admin-bar-refresh-without-cache"><a class="ab-item" role="menuitem" href="javascript:void(0)" onclick="refreshWithCacheParam();">Refresh with cache</a></li>'
  );

  jQuery(document).keydown((e) => {
    if (e.keyCode == 82 && e.ctrlKey) {
      refreshWithCacheParam();
      e.preventDefault();
      e.stopPropagation();
    }
  });

  const enableTimestampCheck = async (
    checkIntervalSeconds = 5,
    quarantineIntervalSeconds = 7
  ) => {
    const loadTimestamp = async () => {
      const response = await fetch(
        "/wp-content/themes/dreamtheme-child/deploytimestamp.txt"
      );
      return await response.text();
    };

    const lastLoadedTimestamp = await loadTimestamp();
    const triggerTimestampCheck = async () => {
      const newTimestamp = await loadTimestamp();

      // Check new timestamp and make sure it's more than 15s since last change
      if (
        lastLoadedTimestamp != newTimestamp &&
        new Date().getTime() - new Date(parseFloat(newTimestamp)).getTime() >
          quarantineIntervalSeconds * 1000
      ) {
        refreshWithCacheParam();
      } else {
        setTimeout(triggerTimestampCheck, checkIntervalSeconds * 1000);
      }
    };
    setTimeout(triggerTimestampCheck, checkIntervalSeconds * 1000);
  };

  if (
    ENABLE_FEATURE_DEBUG_AUTO_REFRESH &&
    window.location.hash === "#componentindev"
  ) {
    enableTimestampCheck();
  }
}
